module.exports = __webpack_public_path__ + "static/manna-sm-c534a78e010b6cffd5194550ff0e4d55.jpg";